import React, { useState, useEffect } from 'react';

import { useGetCategorySubCategoryListQuery } from '../../collection/techpack-journey/api/MultipleTechpackJourneyApi';
import { useGetManufacturedDesignsQuery } from '../api/supplierConfigurationApi';

import DevelopedProductAddModal from './DevelopedProductAddModal';
import DevelopedProductViewModal from './DevelopedProductViewModal';
const DevelopedProducts = ({ detailsInfo }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isViewModalOpen, setIsViewModalOpen] = useState(false);
	const [viewModalActiveTab, setViewModalActiveTab] = useState('all');
	const [categorySubCategoryList, setCategorySubCategoryList] = useState([]);
	const [manufacturedDesigns, setManufacturedDesigns] = useState([]);
	const supplierId = detailsInfo?.id;
	const { data: categorySubCategoryListData } = useGetCategorySubCategoryListQuery();

	const { data: manufacturedDesignsData, isLoading: isManufacturedDesignsLoading } =
		useGetManufacturedDesignsQuery(supplierId, {
			skip: !supplierId
		});

	useEffect(() => {
		if (categorySubCategoryListData) {
			setCategorySubCategoryList(categorySubCategoryListData);
		}
		if (manufacturedDesignsData) {
			setManufacturedDesigns(manufacturedDesignsData?.payload || []);
		}
	}, [categorySubCategoryListData, manufacturedDesignsData]);

	const handleOpenViewAll = () => {
		setViewModalActiveTab('all');
		setIsViewModalOpen(true);
	};

	const handleOpenSubCategoryView = (subCategoryId) => {
		setViewModalActiveTab(subCategoryId || 'all');
		setIsViewModalOpen(true);
	};

	return (
		<>
			<div className="supplier-product-section section-padding">
				<h3 className="suplier-title pb-4 font-weight-bold regular-16">Developed products</h3>
				<div className="supplier-product-header d-flex justify-content-between">
					<p className="regular-14 gray_dark_02">{manufacturedDesigns?.length || 0} Styles</p>
					<div className="transparent-select d-flex justify-content-between align-items-center">
						<div className="select-component">
							<p
								className="regular-14 gray_dark_02 cursor-pointer"
								onClick={() => setIsModalOpen(true)}
							>
								Add
							</p>
						</div>
						<div>
							<span
								className="regular-14 gray_dark_02 cursor-pointer"
								onClick={handleOpenViewAll}
							>
								<span className="devided px-1">|</span> View all
							</span>
						</div>
					</div>
				</div>
				<div className="supplier-products">
					{manufacturedDesigns?.length > 0 ? (
						manufacturedDesigns?.slice(0, 8).map((design) => (
							<div
								key={design.id}
								className="single-collection-item cursor-pointer"
								onClick={() => handleOpenSubCategoryView(design?.subCategoryId)}
							>
								<div className="product-img-container">
									<div className="prev-img">
										<img src={design?.documents?.[0]?.docUrl} />
									</div>
									<div className="prev-img-thumb">
										<div className="single-first">
											<img src={design?.documents?.[1]?.docUrl} />
										</div>
										<div className="single-second">
											<img src={design?.documents?.[2]?.docUrl} />
										</div>
									</div>
								</div>
								<div className="design-details d-flex justify-content-between">
									<div className="details">
										<p className="regular-14 mt-1 mb-0 gray_dark_02">
											{design?.subCategoryName?.charAt(0)?.toUpperCase() +
												design?.subCategoryName?.slice(1)?.toLowerCase()}
										</p>
									</div>
								</div>
							</div>
						))
					) : (
						<p>No designs available</p>
					)}
				</div>
			</div>
			{isModalOpen && (
				<DevelopedProductAddModal
					categorySubCategoryList={categorySubCategoryList}
					onClose={() => setIsModalOpen(false)}
					supplierId={supplierId}
				/>
			)}

			{isViewModalOpen && (
				<DevelopedProductViewModal
					supplierId={supplierId}
					manufacturedDesigns={manufacturedDesigns}
					initialActiveTab={viewModalActiveTab}
					onClose={() => setIsViewModalOpen(false)}
					isManufacturedDesignsLoading={isManufacturedDesignsLoading}
				/>
			)}
		</>
	);
};
export default DevelopedProducts;
